import { Icon } from '@busybusy/webapp-react-ui';
import { NoGPSIcon } from 'assets/icons';
import UpgradePromptView from 'containers/settings/subscriptions/UpgradePromptView/UpgradePromptView';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';
import './GpsUnavailableView.scss';

export interface IGpsUnavailableViewProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
}

const GpsUnavailableView = (props: IGpsUnavailableViewProps) => {
  const { className, isOpen, onClose } = props;

  return (
    <UpgradePromptView
      className={className}
      icon={<Icon svg={NoGPSIcon} size={64} />}
      title={t('GPS Unavailable')}
      description={t(
        'Your current plan no longer supports viewing GPS locations of other employees. If you need more flexibility, please consider upgrading your plan.'
      )}
      offerDescription={t(
        "We'd like to offer you two exclusive, reduced-price plan options not available to all customers."
      )}
      viewType="gps_unavailable"
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default GpsUnavailableView;
